'use client';

import { AD_PLACEMENTS } from '../adPlacements';
import { NativeAdSlot } from '../NativeAdSlot';

export const DonationOrderedGiftAd = () => (
  <NativeAdSlot {...AD_PLACEMENTS.donationOrderedGift} className="mx-auto" />
);
